<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ backgroundColor }">
        <path
            d="M8.34 22C8.24 22 8.12 22 8 22H8.34ZM26.82 10H18V14H25.18L29.18 18H22L14 22L10 18H0V22H8C3.58 22 0 25.58 0 30C0 34.42 3.58 38 8 38C12.42 38 16 34.42 16 30L20 34H26L32.98 21.8L35 23.82C33.18 25.28 32 27.5 32 30C32 34.42 35.58 38 40 38C44.42 38 48 34.42 48 30C48 25.58 44.42 22 40 22C39.64 22 39.28 22.06 38.94 22.1L34.82 18H40V12L32.56 15.72L26.82 10ZM40 34C37.8 34 36 32.2 36 30C36 27.8 37.8 26 40 26C42.2 26 44 27.8 44 30C44 32.2 42.2 34 40 34ZM8 34C5.8 34 4 32.2 4 30C4 27.8 5.8 26 8 26C10.2 26 12 27.8 12 30C12 32.2 10.2 34 8 34Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
